import styles from "./Library.module.css";

import { Header } from "shared/Header/Header";
import { PageHead } from "gui/head/head";

import { SessionWithUser } from "lib/users/types";
import { Sort } from "./useOrderState";
import { UpdatedRecently } from "./UpdatedRecently";
import { Toolbar } from "./Toolbar";
import { TabContent } from "./TabContent";
import { useListFolders } from "./ListFolders/useListFolders";
import { Filter } from "./Filters";

export interface ApiParams {
  filter: Filter;
  order: Sort;
  page: number;
  pageSize: number;
}

interface Props {
  session: SessionWithUser;
}

export const Library = (props: Props) => {
  const foldersResult = useListFolders(props.session);
  const foldersCount = foldersResult.data?.get_folders.results.length ?? 0;

  const refetchFolders = async () => {
    await foldersResult.refetch();
  };

  return (
    <>
      <PageHead title="Library" />
      <div className={styles.page}>
        <Header />
        <main>
          <UpdatedRecently session={props.session} />

          <Toolbar
            refetchFolders={refetchFolders}
            foldersCount={foldersCount}
          />

          <TabContent session={props.session} />
        </main>
      </div>
    </>
  );
};
